module.exports = __webpack_public_path__ + "img/thumb-003.6de81660.png";